import ProcessTerminatePage from './ProcessTerminatePage';

export default ProcessTerminatePage;
